import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_PRIORITY, GET_PRIORITY_SUCCESS, GET_PRIORITY_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getPriority({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/priorities`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_PRIORITY_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_PRIORITY_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_PRIORITY_ERROR, payload: error });
  }
}

export function* watchGetPriority() {
  yield takeEvery(GET_PRIORITY, getPriority);
}

function* getPrioritySaga() {
  yield all([fork(watchGetPriority)]);
}

export default getPrioritySaga;